import { comdex } from "../config/network";
import {
    AccountStore,
    AccountWithCosmos,
    ChainStore,
    getKeplrFromWindow,
    QueriesStore,
    QueriesWithCosmos,
} from '@keplr-wallet/stores';
import { MemoryKVStore } from '@keplr-wallet/common';

// export const contractAddr = "comdex17p9rzwnnfxcjp32un9ug7yhhzgtkhvl9jfksztgw5uh69wac2pgs4jg6dx";
export const contractAddr = "comdex14hj2tavq8fpesdwxxcu44rty3hh90vhujrvcmstl4zr3txmfvw9spunaxy";

export const getChainConfig = () => {
    return {
        chainId: comdex?.chainId,
        chainName: comdex?.chainName,
        rpc: comdex?.rpc,
        rest: comdex?.rest,
        stakeCurrency: {
            coinDenom: comdex?.coinDenom,
            coinMinimalDenom: comdex?.coinMinimalDenom,
            coinDecimals: comdex?.coinDecimals,
        },
        bip44: {
            coinType: 118,
        },
        bech32Config: {
            bech32PrefixAccAddr: `${comdex?.prefix}`,
            bech32PrefixAccPub: `${comdex?.prefix}pub`,
            bech32PrefixValAddr: `${comdex?.prefix}valoper`,
            bech32PrefixValPub: `${comdex?.prefix}valoperpub`,
            bech32PrefixConsAddr: `${comdex?.prefix}valcons`,
            bech32PrefixConsPub: `${comdex?.prefix}valconspub`,
        },
        currencies: [
            {
                coinDenom: comdex?.coinDenom,
                coinMinimalDenom: comdex?.coinMinimalDenom,
                coinDecimals: comdex?.coinDecimals,
            },
        ],
        feeCurrencies: [
            {
                coinDenom: comdex?.coinDenom,
                coinMinimalDenom: comdex?.coinMinimalDenom,
                coinDecimals: comdex?.coinDecimals,
            },
        ],
        coinType: 118,
        gasPriceStep: {
            low: 0.0,
            average: 0.0,
            high: 0.0,
        },
    };
};
export const initializeChain = (callback) => {
    (async () => {
        if (!window.getOfflineSigner || !window.keplr) {
            const error = "Please install keplr extension";
            callback(error);
        } else {
            if (window.keplr.experimentalSuggestChain) {
                try {
                    await window.keplr.experimentalSuggestChain(getChainConfig());
                    const offlineSigner = window.getOfflineSigner(comdex?.chainId);
                    const accounts = await offlineSigner.getAccounts();
                    // console.log(accounts);
                    callback(null, accounts[0]);
                } catch (error) {
                    callback(error?.message);
                }
            } else {
                const versionError = "Please use the recent version of keplr extension";
                callback(versionError);
            }
        }
    })();
};

export const initializeIBCChain = (config, callback) => {
    (async () => {
        if (!window.getOfflineSigner || !window.keplr) {
            const error = "Please install keplr extension";

            callback(error);
        } else {
            if (window.keplr.experimentalSuggestChain) {
                try {
                    await window.keplr.experimentalSuggestChain(config);
                    const offlineSigner = window.getOfflineSigner(config?.chainId);
                    const accounts = await offlineSigner.getAccounts();
                    callback(null, accounts[0]);
                } catch (error) {
                    callback(error?.message);
                }
            } else {
                const versionError = "Please use the recent version of keplr extension";
                callback(versionError);
            }
        }
    })();
};


export const KeplrWallet = async (chainID = comdex?.chainId) => {
    await window.keplr.enable(chainID);
    const offlineSigner = window.getOfflineSigner(chainID);
    const accounts = await offlineSigner.getAccounts();
    return [offlineSigner, accounts];
};

export const fetchKeplrAccountName = () => {
    const chainStore = new ChainStore([getChainConfig()]);
    const queriesStore = new QueriesStore(
        new MemoryKVStore('test_store_web_queries'),
        chainStore,
        getKeplrFromWindow,
        QueriesWithCosmos,
    );

    const accountStore = new AccountStore(
        window,
        AccountWithCosmos,
        chainStore,
        queriesStore,
        {
            defaultOpts: {
                prefetching: false,
                suggestChain: false,
                autoInit: true,
                getKeplr: getKeplrFromWindow,
            },
        },
    );
    // console.log(accountStore?.getAccount(comdex?.chainId));
    return accountStore.getAccount(comdex?.chainId);
};